export const API_HOST = process.env.REACT_APP_API_HOST ?? "http://127.0.0.1:3000"